import api from "@/services/api/baseService";

class apiInventoriesService {
  list(page, per_page, q) {
    return api
      .get("/inventories", {
        headers: {
          // Authorization: `Bearer ${localStorage.token}`,
        },
        params: {
          page,
          per_page,
          q,
        },
      })
      .then((response) => response)
      .catch((error) => error.response);
  }
  getInventory(id) {
    return api
      .get(`/inventories/${id}`, {
        headers: {
          // Authorization: `Bearer ${localStorage.token}`,
        },
      })
      .then((response) => response)
      .catch((error) => error.response);
  }
  create(inventory) {
    return api
      .post("/inventories/add", inventory, {
        headers: {
          // Authorization: `Bearer ${localStorage.token}`,
        },
      })
      .then((response) => response)
      .catch((error) => error.response);
  }
  update(inventory, id) {
    return api
      .put(`/inventories/${id}`, inventory, {
        headers: {
          // Authorization: `Bearer ${localStorage.token}`,
        },
      })
      .then((response) => response)
      .catch((error) => error.response);
  }
  updateInventory(inventory) {
    return api
      .post("/inventories/update-quantity", inventory, {
        headers: {
          // Authorization: `Bearer ${localStorage.token}`,
        },
      })
      .then((response) => response)
      .catch((error) => error.response);
  }
  upload(inventory) {
    return api
      .post(`/inventories`, inventory, {
        headers: {
          // Authorization: `Bearer ${localStorage.token}`,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => response)
      .catch((error) => {
        throw error;
      });
  }
}

export default new apiInventoriesService();
